'use client';
import BondPosition from '@/components/common/BondPosition';
import * as bondDetailAction from '@/redux/actions/bondDetails';
import * as bondsAction from '@/redux/actions/bonds';
import { EXIST_LOCAL_STORAGE } from '@/services/constants/app';
import { getEncryptedText, getStorage } from '@/services/helperFunctions';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import React, { memo, Suspense, useCallback, useEffect, useMemo, useState } from 'react';
import { Bookmark, BookmarkCheckFill } from 'react-bootstrap-icons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BondAnalytics from './BondAnalytics';
import { makeNavigationSiteAnalytics } from '@/services/simpleApis';
const IPopover = dynamic(() => import('./bondHeaderComponents/IPopover'), { ssr: false });

interface BondData {
    description: string;
    bond_name: string;
    industry: string;
    issuer: string;
    issuer_short_name: string;
    isin: string;
    currency_code: string;
    currency_symbol: string;
    maturity_date: string;
    maturity: string;
    pricing_date: string;
    low: null | number;
    ytm: null | number;
    ytw: null | number;
    high: null | number;
    price: null | number;
    clean_price: null | number;
    yield: null | number;
    coupon: number;
    dirty_price: null | number;
    change_percentage: number;
    follow_bond: null | boolean;
}
const BondHeader = ({
    isLoggedIn,
    getBondsHeader,
    getBondDetailToken,
    bondID,
    bondsHeaderDetail,
    getfollowBond,
    initialBondsHeaderDetail,
    initialBondsAnalyticsDetail,
    getBondAnalytics,
}: any) => {
    const [showDirtyPrice, setShowDirtyPrice] = useState(false);
    const isSeoPage = false;

    const userId = getStorage(EXIST_LOCAL_STORAGE.USER_ID);
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(isLoggedIn);

    useEffect(() => {
        setIsUserLoggedIn(!!userId);
    }, [userId]);

    useEffect(() => {
        if (isUserLoggedIn && bondID) {
            handleGetBondsHeaderList();
        }
    }, [isUserLoggedIn, bondID]);

    const [bondDetailLoading, setBondDetailLoading] = useState(true);
    const handleGetBondsHeaderList = useCallback(async () => {
        setBondDetailLoading(true);
        const tokenData = await getBondDetailToken();
        const body = {
            params: {
                user_id: userId,
                isin: getEncryptedText(tokenData.data + bondID),
                seo: isSeoPage,
            },
        };
        getBondsHeader(body)
            .then((res: any) => {
                if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
                    setIsFollowingBond(!!res?.data[0]?.follow_bond);
                }
            })
            .finally(() => {
                setBondDetailLoading(false);
            });
    }, [getBondsHeader, bondID, userId, getBondDetailToken]);

    const handleDirtyPrice = () => {
        setShowDirtyPrice(!showDirtyPrice);
    };

    const [yieldColumn, setYieldColumn] = useState('yield');

    const handleYieldClick = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const val = event.target.value;
        if (yieldColumn === 'yield') {
            setYieldColumn(val);
        } else if (yieldColumn === 'ytm') {
            setYieldColumn(val);
        } else if (yieldColumn === 'ytw') {
            setYieldColumn(val);
        }
    };

    const handleBondLazyLoading = useMemo(() => !bondDetailLoading, [bondDetailLoading]);

    const bondData: BondData | null = useMemo(
        () =>
            Array.isArray(bondsHeaderDetail?.data)
                ? bondsHeaderDetail?.data?.[0]
                : Array.isArray(initialBondsHeaderDetail)
                  ? initialBondsHeaderDetail[0]
                  : null,
        [initialBondsHeaderDetail, bondsHeaderDetail?.data]
    );

    console.log('bondsHeaderDetail', bondsHeaderDetail);

    const [isFollowingBond, setIsFollowingBond] = useState<boolean>(false);

    const handleFollowBond = useCallback(() => {
        const body = {
            isin: bondID,
            user_id: userId,
        };
        getfollowBond(body);
        setIsFollowingBond((prev) => !prev);
    }, [getfollowBond, bondID, userId]);

    const [showPosition, setShowPosition] = useState(false);

    const handleShowPosition = () => setShowPosition(true);

    const handleClosePosition = () => setShowPosition(false);

    return (
        <div className="row mt-2">
            <div className="col-md-12">
                <div className="row card-body bg-light pt-3">
                    <div
                        className="d-flex flex-column pb-2 align-items-center align-items-lg-start flex-lg-row"
                        style={{
                            borderBottom: '1px solid #9f9f9f7a',
                            paddingBottom: '5px',
                            fontSize: '21px!important',
                        }}
                    >
                        <div className="col">
                            <div className="d-flex justify-content-between align-items-start">
                                <div className="col-12">
                                    <h1 style={{ fontSize: 24 }} className="px-3 py-1">{`${
                                        bondData?.issuer_short_name || bondData?.issuer || ''
                                    } bond | ${bondData?.coupon ? bondData?.coupon?.toFixed(2) + '%' : ''} ${bondData?.maturity || ''} ${
                                        bondData?.currency_code || ''
                                    } | ${bondData?.isin || ''}`}</h1>
                                </div>
                            </div>
                            <div className="row align-items-center justify-content-between mt-1 px-3" style={{ minHeight: 38 }}>
                                <div className={`col-6 col-lg-8 col-md-5`}>
                                    <div className="d-flex align-items-center gap-1">
                                        <h2
                                            className={`fw-semibold m-0 ${
                                                bondData?.change_percentage
                                                    ? bondData?.change_percentage > 0
                                                        ? 'text-success'
                                                        : 'text-danger'
                                                    : 'text-muted'
                                            }`}
                                            style={{ fontSize: 12 }}
                                        >
                                            <span className="text-muted">Change % : </span>
                                            {bondData?.change_percentage ? (bondData?.change_percentage > 0 ? '▲' : '▼') : ''}
                                            {bondData?.change_percentage
                                                ? bondData?.change_percentage > 0
                                                    ? ' +' + bondData?.change_percentage?.toFixed(3) + '%'
                                                    : bondData?.change_percentage?.toFixed(3) + '%'
                                                : bondData?.change_percentage == 0
                                                  ? bondData?.change_percentage?.toFixed(2)
                                                  : ' -'}
                                        </h2>
                                    </div>
                                </div>
                                {isUserLoggedIn && handleBondLazyLoading && (
                                    <div
                                        className="col d-flex gap-2 align-items-center user-select-none shibui-text"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {handleBondLazyLoading && isFollowingBond ? (
                                            <BookmarkCheckFill className="cursor-pointer user-select-none1" onClick={handleFollowBond} />
                                        ) : (
                                            <Bookmark className="cursor-pointer user-select-none1" onClick={handleFollowBond} />
                                        )}

                                        {isUserLoggedIn && (
                                            <>
                                                <button
                                                    type="button"
                                                    style={{ margin: '5px 5px' }}
                                                    className="btn btn-outline-secondary btn-sm bond-position-btn-cus shibui-border shibui-text"
                                                    onClick={handleShowPosition}
                                                >
                                                    Buy | Sell
                                                </button>
                                                <BondPosition show={showPosition} bondId={bondID} onclose={handleClosePosition} />
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div
                                className={`col col-9 user-select-none1 d-flex align-items-center justify-content-between`}
                                style={{ paddingRight: !isSeoPage ? '5.5%' : '12.5%' }}
                            ></div>
                        </div>
                        {!isUserLoggedIn && (
                            <div className="col-11 col-md-9 col-lg-4 my-3 my-lg-0 d-flex flex-column align-items-center mb-2 justify-content-between shibui-shadow rounded p-2">
                                <p className="text-center text-sm mb-2 fs-6 m-0">
                                    View all data <span className="fw-bold">FOR FREE!</span>
                                </p>
                                <p className="text-center text-xs mb-1 m-0 mx-1">Create an account today, no credit card required.</p>
                                <Link
                                    href="/registerpage"
                                    className="text-white"
                                    onClick={() => void makeNavigationSiteAnalytics('Get Free Data', '/registerpage')}
                                >
                                    <button className="call-to-action-button d-flex align-items-center fw-bold px-5 py-1">
                                        Get Free Data
                                        <span className="ms-1">→</span>
                                    </button>
                                </Link>
                            </div>
                        )}
                    </div>
                    <div
                        className="row user-select-none1  overview-container-mob justify-content-between mx-auto mx-lg-0"
                        style={{ paddingTop: 10 }}
                    >
                        <div className={`${isSeoPage ? 'col-md-7' : 'col-md-8'}`}>
                            <section className="overview-section">
                                <div className="d-flex justify-content-between">
                                    <h2 className="text fw-bold" style={{ fontSize: '15px', width: 'max-content' }}>
                                        Overview
                                    </h2>{' '}
                                    <span className="fst-italic text-sm">
                                        {!!bondData?.pricing_date &&
                                            'pricing as of ' + new Date(`${bondData.pricing_date}Z`).toISOString().substring(0, 10)}
                                    </span>
                                </div>
                                <div className="card-group d-flex row">
                                    {/* Yield Card */}
                                    <div className="bd-card card col border-light">
                                        <div className="card-body">
                                            <label
                                                className="card-subtitle mb-2"
                                                style={{
                                                    color: '#294672',
                                                    cursor: 'pointer',
                                                    fontSize: '12px',
                                                    fontWeight: '700',
                                                }}
                                            >
                                                <select
                                                    className="custom-select"
                                                    onChange={handleYieldClick}
                                                    style={{
                                                        border: '1px solid #ced4da',
                                                        borderRadius: '5px',
                                                    }}
                                                    defaultValue="yield"
                                                >
                                                    <option value="yield">Yield(%)</option>
                                                    <option value="ytm">YTM(%)</option>
                                                    <option value="ytw">YTW(%)</option>
                                                </select>
                                            </label>
                                            <div className={`card-title d-flex`}>
                                                <span>
                                                    {isSeoPage && handleBondLazyLoading && 'xxxxxx'}
                                                    {!isSeoPage && yieldColumn === 'yield'
                                                        ? bondData?.yield != null
                                                            ? bondData?.yield?.toFixed(2)
                                                            : '–'
                                                        : ''}
                                                    {!isSeoPage && yieldColumn === 'ytm'
                                                        ? bondData?.ytm != null
                                                            ? bondData?.ytm?.toFixed(3)
                                                            : '–'
                                                        : ''}
                                                    {!isSeoPage && yieldColumn === 'ytw'
                                                        ? bondData?.ytw != null
                                                            ? bondData?.ytw?.toFixed(3)
                                                            : '–'
                                                        : ''}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Coupon Card */}
                                    <div className="bd-card user-select-none1 card col border-light">
                                        <div className="card-body coupon-card-body-mob">
                                            <label
                                                className={`card-subtitle mb-2 `}
                                                style={{
                                                    color: '#294672',
                                                    lineHeight: '18px',
                                                    marginTop: '1px',
                                                    fontSize: '12px',
                                                    fontWeight: '700',
                                                }}
                                            >
                                                Coupon
                                            </label>
                                            <div className={`card-title mt-2`}>
                                                {bondData?.coupon != null && bondData?.coupon !== 0 ? bondData?.coupon?.toFixed(3) : 'ZC'}
                                            </div>
                                        </div>
                                    </div>
                                    {/* price card */}
                                    <div className="bd-card card col border-light">
                                        <div className="card-body">
                                            <label
                                                className="card-subtitle mb-2"
                                                style={{
                                                    color: '#294672',
                                                    cursor: 'pointer',
                                                    fontSize: '12px',
                                                    fontWeight: '700',
                                                }}
                                            >
                                                <select
                                                    className="custom-select "
                                                    onChange={handleDirtyPrice}
                                                    style={{
                                                        border: '1px solid #ced4da',
                                                        borderRadius: '5px',
                                                    }}
                                                >
                                                    <option value="">Clean Price </option>
                                                    <option value="">Dirty Price </option>
                                                </select>
                                            </label>
                                            <Suspense fallback={null}>
                                                <IPopover iconColor="#294672" />
                                            </Suspense>
                                            <div className={`card-title mt-2`}>
                                                {showDirtyPrice
                                                    ? bondData?.dirty_price === null
                                                        ? 'N/A'
                                                        : bondData?.dirty_price?.toFixed(3)
                                                    : bondData?.clean_price === null
                                                      ? 'N/A'
                                                      : bondData?.clean_price?.toFixed(3)}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-group card-group row">
                                    {/* Maturity Info Cards  */}
                                    <div className=" bd-card card  border-light">
                                        <div className="card-body">
                                            <label
                                                className="card-subtitle mb-2 "
                                                style={{
                                                    color: '#294672',
                                                    fontSize: '12px',
                                                    fontWeight: '700',
                                                }}
                                            >
                                                Maturity
                                            </label>
                                            <div className={`card-title`}>
                                                {bondData?.maturity != null ? bondData?.maturity.split('T')[0] : 'N/A'}
                                            </div>
                                        </div>
                                    </div>
                                    {/* Currency Cards  */}
                                    <div className=" bd-card card  border-light">
                                        <div className="card-body">
                                            <label
                                                className="card-subtitle mb-2 "
                                                style={{
                                                    color: '#294672',
                                                    fontSize: '12px',
                                                    fontWeight: '700',
                                                }}
                                            >
                                                Currency
                                            </label>
                                            <div className={`card-title`}>
                                                {bondData?.currency_code != null ? bondData?.currency_code : 'N/A'}
                                            </div>
                                        </div>
                                    </div>
                                    {/* High/Low Cards  */}
                                    <div className="bd-card card  border-light" style={{ maxHeight: '96px' }}>
                                        <div className="card-body ">
                                            <label
                                                className="card-subtitle text-wrap mb-2 "
                                                style={{
                                                    color: '#294672',
                                                    fontSize: '12px',
                                                    fontWeight: '700',
                                                }}
                                            >
                                                High/Low <span>(52 week)</span>
                                            </label>
                                            {
                                                <div className={`card-title ms-1`}>
                                                    {bondData?.high || bondData?.low ? bondData?.high + '/' + bondData?.low : '-'}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div className="col-md-4 pb-4">
                            <BondAnalytics
                                getBondAnalytics={getBondAnalytics}
                                bondID={bondID}
                                initialBondsAnalyticsDetail={initialBondsAnalyticsDetail}
                                // isLoading={isBondsAnalyticsLoader}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
const mapStatesToProps = ({
    bondsDetail: {
        bondsHeaderDetail = [],
        bondsDetailData,
        isBondsDetailDataLoader = false,
        isBondsHeaderDetailLoader = false,
        isSameIssuerBondsLoader = false,
        sameIssuerBondsData = {},
    },
}: any) => {
    return {
        bondsHeaderDetail,
        isBondsHeaderDetailLoader,
        bondsDetailData,
        isBondsDetailDataLoader,
        isSameIssuerBondsLoader,
        sameIssuerBondsData,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators(
        {
            ...bondsAction,
            ...bondDetailAction,
        },
        dispatch
    );
};

export default memo(connect(mapStatesToProps, mapDispatchToProps)(BondHeader));
